import { Dayjs } from 'dayjs';
import { FileData, FileTypes } from './false-deals-admin.types';
import {
    FILESIZE_LIMIT,
    FILES_LIMIT,
    NO_NAME,
    REQUEST_DATE_FORMAT,
    TAXPAYER_TYPES,
    fileFieldsLabels,
} from './false-deals-admin.constants';
import { Rule } from 'antd/es/form';
import { downloadAttachment } from './actions';

const priorities = ['ru', 'kk', 'en', 'qq'];

export const getAnonimousOption = (type: keyof typeof TAXPAYER_TYPES): string =>
    [TAXPAYER_TYPES[type] || '', NO_NAME].join(' ');

export const getTaxpayerOptions = (taxpayers) => {
    return taxpayers.map((taxpayer) => {
        for (const key of priorities) {
            if (taxpayer.name[key] && taxpayer.name[key]?.trim()) {
                const value = taxpayer.name[key].trim();
                return {
                    key: taxpayer.type,
                    label: value,
                    value,
                };
            }
        }
        let name = ['lastname', 'firstname', 'middlename']
            .map((part) => taxpayer.name[part]?.trim())
            .filter(Boolean)
            .join(' ');
        if (!name) {
            name = getAnonimousOption(taxpayer.type);
        } else {
            if (!taxpayer.type.startsWith('FL')) {
                name = `${TAXPAYER_TYPES[taxpayer.type]} ${name}`;
            }
        }
        return { key: taxpayer.type, label: name, value: name };
    });
};

export const appendFiles = (formData: FormData, field: FileTypes, files: any[]) => {
    if (!files || !Array.isArray(files)) return;
    for (const file of files) {
        formData.append(field, file.originFileObj);
    }
};

export const formatDates = (values: any) => {
    const { dateCompilation, datePlacement, ...rest } = values;
    const [createdDateFrom, createdDateTo] = (datePlacement || []).map((date: Dayjs) =>
        date.format(REQUEST_DATE_FORMAT)
    );
    const [preparationDateFrom, preparationDateTo] = (dateCompilation || []).map((date: Dayjs) =>
        date.format(REQUEST_DATE_FORMAT)
    );

    const formatted = {
        ...rest,
        createdDateFrom,
        createdDateTo,
        preparationDateFrom,
        preparationDateTo,
    };

    return Object.fromEntries(Object.entries(formatted).filter(([, value]) => Boolean(value)));
};

export const sizeToBytes = (sizeMb: number): number => sizeMb * 1024 * 1024;

export const getFilesValidationRule = (
    required = true,
    totalFiles = FILES_LIMIT,
    totalFileSize = FILESIZE_LIMIT
): Rule => ({
    validator({ field }: any, value: File[]) {
        if (required && (!value || value.length === 0)) {
            const fileType = fileFieldsLabels[field].toLowerCase();
            return Promise.reject(new Error(`Выберите ${fileType}`));
        }
        if (value && value.length > totalFiles) {
            return Promise.reject(new Error('Превышено максимальное количество файлов'));
        }
        if (value?.reduce((acc, file) => acc + file.size, 0) > sizeToBytes(totalFileSize)) {
            return Promise.reject(new Error('Превышен максимальный объем файлов'));
        }
        return Promise.resolve();
    },
});

export const downloadRecordFile = async (file: FileData) => {
    const response = await downloadAttachment(file.fileId);

    const blob = new Blob([response.data], { type: response.data.type });
    const bloblUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = bloblUrl;
    link.download = file.fileName;
    link.click();
    link.remove();
};
